import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: React.ReactNode;
  delay?: number;
}

export const PageTransition: React.FC<PageTransitionProps> = ({ children, delay = 50 }) => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const [currentPath, setCurrentPath] = useState(location.pathname);

  useEffect(() => {
    // Page change detected
    if (location.pathname !== currentPath) {
      setIsVisible(false);
      setCurrentPath(location.pathname);
      
      // Small delay to prevent flash
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, delay);
      
      return () => clearTimeout(timer);
    } else {
      // Initial load or same page
      setIsVisible(true);
    }
  }, [location.pathname, currentPath, delay]);

  return (
    <div 
      className={`transition-all duration-200 ease-in-out ${
        isVisible 
          ? 'opacity-100 translate-y-0' 
          : 'opacity-0 translate-y-2'
      }`}
    >
      {children}
    </div>
  );
};

export default PageTransition; 